import { Link } from 'react-router-dom';
import GoogleReviewsBadge from '@/components/GoogleReviewsBadge';
import { HERO, HOME_HERO_SIZES } from '@/lib/brandImages';

// No entrance animation here on purpose: the hero must paint instantly (it's the page's main content for Google).

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20">
      <div className="max-w-[1600px] mx-auto w-full px-6 md:px-10 lg:px-16 py-12 md:py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="caps-label text-orange mb-6">Property Inventory &amp; Safety Services</p>
            <h1 className="font-display font-extrabold text-navy mono-number" style={{ fontSize: 'clamp(2.5rem, 7vw, 5.5rem)' }}>
              10 YEARS.<br />20,000<br />LANDLORDS.
            </h1>
            <div className="mt-6">
              <GoogleReviewsBadge variant="light" />
            </div>
            <p className="text-lg text-muted-foreground mt-8 max-w-md leading-relaxed">
              Trusted property inventory, safety certification, and cleaning services across London and Manchester.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-10">
              <Link to="/request-quote" className="px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors text-center">
                Request Quote
              </Link>
              <Link to="/book-now" className="px-8 py-4 bg-navy text-white font-semibold rounded-full hover:bg-navy-light transition-colors text-center">
                Book Now
              </Link>
            </div>
          </div>
          <div className="relative h-[300px] sm:h-[400px] lg:h-[600px] overflow-hidden">
            <img
              src={HERO.src}
              srcSet={HERO.srcSet}
              sizes={HOME_HERO_SIZES}
              width={HERO.width}
              height={HERO.height}
              alt="Modern London penthouse interior at dusk"
              loading="eager"
              fetchpriority="high"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}